<template>
  <!-- 与 WP 页 body 一致：post-9.css 依赖 .elementor-kit-9 提供全局变量与背景 -->
  <div ref="t4Page"
       class="home-type4-root home wp-singular page page-id-12 elementor-default elementor-kit-9 elementor-page elementor-page-12"
       @pointerenter="onPtrEnter"
       @pointerleave="onPtrLeave"
       @pointermove="onPtrMove">
    <!-- 光标附近网格高亮层 -->
    <div class="grid-focus"
         aria-hidden="true"></div>
    <!-- 光标柔光层 -->
    <div ref="glowEl"
         class="cursor-glow"
         aria-hidden="true"></div>
    <!-- 页面头部 -->
    <pageHeader :homeInfo="homeInfo"
                :expert="expertConfig.expert"
                @handleChangeExpert="handleChangeExpert" />

    <main id="content"
          class="site-main post-12 page type-page status-publish has-post-thumbnail hentry">
      <div class="page-content">
        <div data-elementor-type="wp-page"
             data-elementor-id="12"
             class="elementor elementor-12"
             data-elementor-post-type="page">
          <div class="elementor-element elementor-element-19ee778 e-flex e-con-boxed e-con e-parent e-lazyloaded"
               data-id="19ee778"
               data-element_type="container"
               data-e-type="container">
            <div class="e-con-inner">
              <div class="elementor-element elementor-element-4c235ad elementor-widget elementor-widget-heading"
                   data-id="4c235ad"
                   data-element_type="widget"
                   data-e-type="widget"
                   data-widget_type="heading.default">
                <h1 class="elementor-heading-title elementor-size-default">
                  {{ homeInfo.homeContent.title1 }}
                </h1>
              </div>

              <!-- 新品 轮播 -->
              <carousel :goodsData="homeInfo?.goodsList?.['New Arrivals'] || []"
                        :selectPlatform="selectPlatform" />

              <div class="elementor-element elementor-element-804f0dc elementor-widget elementor-widget-heading"
                   data-id="804f0dc"
                   data-element_type="widget"
                   data-e-type="widget"
                   data-widget_type="heading.default">
                <h2 class="elementor-heading-title elementor-size-default">
                  {{ homeInfo.homeContent.title2 }}
                </h2>
              </div>
            </div>
          </div>

          <!-- 热销商品 -->
          <bestseller :goodsData="homeInfo?.goodsList?.['Best Sellers'] || []"
                      :selectPlatform="selectPlatform" />

          <!-- 关于我们 -->
          <div v-if="homeInfo?.homeContent?.pcImage1"
               class="elementor-element elementor-element-0657ed6 e-flex e-con-boxed e-con e-parent e-lazyloaded"
               data-id="0657ed6"
               data-element_type="container"
               data-e-type="container"
               style="border: none;">
            <div class="e-con-inner">
              <div class="elementor-element elementor-element-3f0646c elementor-widget elementor-widget-image"
                   data-id="3f0646c"
                   data-element_type="widget"
                   data-e-type="widget"
                   data-widget_type="image.default">
                <img loading="lazy"
                     decoding="async"
                     width="800"
                     height="598"
                     :src="homeInfo?.homeContent?.pcImage1"
                     class="attachment-large size-large wp-image-21172"
                     alt=""
                     sizes="(max-width: 800px) 100vw, 800px">
              </div>
              <div class="elementor-element elementor-element-214aae3 elementor-widget elementor-widget-text-editor"
                   data-id="214aae3"
                   data-element_type="widget"
                   data-e-type="widget"
                   data-widget_type="text-editor.default">
                <p v-html="aboutUsContent">
                </p>
              </div>
            </div>
          </div>

          <div class="elementor-element elementor-element-c6c61aa elementor-hidden-desktop elementor-hidden-tablet elementor-hidden-mobile e-flex e-con-boxed e-con e-parent"
               data-id="c6c61aa"
               data-element_type="container"
               data-e-type="container">
            <div class="e-con-inner">
              <div class="elementor-element elementor-element-9257913 elementor-flip-box--effect-fade elementor-widget__width-initial elementor-widget elementor-widget-flip-box"
                   data-id="9257913"
                   data-element_type="widget"
                   data-e-type="widget"
                   data-widget_type="flip-box.default">
                <div class="elementor-flip-box"
                     tabindex="0">
                  <div class="elementor-flip-box__layer elementor-flip-box__front">
                    <div class="elementor-flip-box__layer__overlay">
                      <div class="elementor-flip-box__layer__inner">
                        <div class="elementor-icon-wrapper elementor-view-default">
                          <div class="elementor-icon">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="elementor-flip-box__layer elementor-flip-box__back">
                    <div class="elementor-flip-box__layer__overlay">
                      <div class="elementor-flip-box__layer__inner">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="elementor-element elementor-element-e246f45 e-con-full e-flex e-con e-child"
                   data-id="e246f45"
                   data-element_type="container"
                   data-e-type="container">
                <div class="elementor-element elementor-element-eabc7c4 elementor-widget elementor-widget-heading"
                     data-id="eabc7c4"
                     data-element_type="widget"
                     data-e-type="widget"
                     data-widget_type="heading.default">
                  <h4 class="elementor-heading-title elementor-size-default">
                    Flavius "CloneSoles"
                    Petru
                  </h4>
                </div>
                <div class="elementor-element elementor-element-006a778 elementor-widget elementor-widget-text-editor"
                     data-id="006a778"
                     data-element_type="widget"
                     data-e-type="widget"
                     data-widget_type="text-editor.default">
                  From HagoBuy &amp; CNFans to Kakobuy — Final Boss.<br><br>

                  I stand as a trailblazer among Romania’s agent content creators, being one of the
                  early adopters to explore and showcase HagoBuy instead of the more conventional
                  platforms at the time. As the market evolved, my journey expanded far beyond simple
                  platform comparisons — I became one of the key voices mastering the entire CNFans
                  ecosystem, learning how agents truly operate behind the scenes.<br><br>

                  Through extensive research, countless orders, and hands-on testing across every
                  major category, I developed a precise understanding of quality, reliability, and the
                  real value hidden within China’s marketplace. I learned what works, what fails, and
                  what people actually deserve when shopping with confidence.<br><br>

                  As the industry moves forward, 2026 marks the next phase — applying that experience
                  to Kakobuy, bringing the same standards, transparency, and real-world testing into a
                  new generation of agent platforms.<br><br>

                  RepGalaxy is the result of that entire journey. It isn’t just a project — it’s the
                  standard I always wished existed in an industry where reliable information is rare
                  and quality varies dramatically. Here, you’ll find products I’ve personally
                  purchased, tested, and approved — items that meet my own benchmarks — helping people
                  navigate HagoBuy, CNFans, and now Kakobuy with clarity, confidence, and zero
                  compromise.
                </div>
                <div class="elementor-element elementor-element-0e3ff5c elementor-mobile-align-center elementor-widget-mobile__width-inherit elementor-align-left elementor-widget elementor-widget-button"
                     data-id="0e3ff5c"
                     data-element_type="widget"
                     data-e-type="widget"
                     id="faq"
                     data-widget_type="button.default">
                  <a class="elementor-button elementor-button-link elementor-size-sm"
                     href="https://repgalaxy.com/flavius/"
                     target="_blank">
                    <span class="elementor-button-content-wrapper">
                      <span class="elementor-button-text">
                        LEARN MORE
                      </span>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <!-- 常见问题解答 -->
          <!-- <faq /> -->
        </div>

        <div class="post-tags">
        </div>
      </div>
    </main>

    <footer data-elementor-type="footer"
            data-elementor-id="18"
            class="elementor elementor-18 elementor-location-footer"
            data-elementor-post-type="elementor_library">
      <div class="elementor-element elementor-element-4f0b3bd e-con-full e-flex e-con e-parent e-lazyloaded"
           data-id="4f0b3bd"
           data-element_type="container"
           data-e-type="container">
        <div class="elementor-element elementor-element-f9a6596 elementor-icon-list--layout-inline elementor-align-center elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
             data-id="f9a6596"
             data-element_type="widget"
             data-e-type="widget"
             data-widget_type="icon-list.default">
          <!-- 页脚社交外链 -->
          <ul class="elementor-icon-list-items elementor-inline-items">
            <li v-for="row in socList"
                :key="row.title"
                class="elementor-icon-list-item elementor-inline-item">
              <a :href="row.linkAddress"
                 target="_blank">
                <span class="elementor-icon-list-icon">
                  <span class="e-font-icon-svg"
                        v-html="row.url" />
                </span>
                <span class="elementor-icon-list-text">
                </span>
              </a>
            </li>
          </ul>
        </div>

        <div v-if="homeInfo?.homeContent?.pcImage2 || statementContent"
             class="elementor-element elementor-element-d79cd43 e-con-full e-flex e-con e-child"
             data-id="d79cd43"
             data-element_type="container"
             data-e-type="container"
             data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
          <div v-if="homeInfo?.homeContent?.pcImage2"
               class="elementor-element elementor-element-90c1ab8 elementor-widget__width-initial elementor-widget-mobile__width-initial elementor-widget elementor-widget-image"
               data-id="90c1ab8"
               data-element_type="widget"
               data-e-type="widget"
               data-widget_type="image.default">
            <a href="">
              <img width="800"
                   height="598"
                   :src="homeInfo?.homeContent?.pcImage2"
                   class="attachment-large size-large wp-image-21172"
                   alt=""
                   sizes="(max-width: 800px) 100vw, 800px">
            </a>
          </div>
          <div class="elementor-element elementor-element-44e4f80 elementor-widget__width-auto elementor-widget-tablet__width-initial elementor-widget elementor-widget-text-editor"
               data-id="44e4f80"
               data-element_type="widget"
               data-e-type="widget"
               data-widget_type="text-editor.default"
               v-html="statementContent"></div>
        </div>

        <div class="elementor-element elementor-element-0383a3b elementor-widget elementor-widget-heading"
             data-id="0383a3b"
             data-element_type="widget"
             data-e-type="widget"
             data-widget_type="heading.default">
          <div class="elementor-heading-title elementor-size-default">
            Copyright 2026 {{ siteDomain }} - All
            Rights Reserved
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import pageHeader from '../module/page-header.vue'
import carousel from './carousel.vue'
import bestseller from './bestseller.vue'
import faq from './faq.vue'

export default {
  components: {
    pageHeader,
    carousel,
    bestseller,
    faq,
  },

  props: {
    homeInfo: {
      type: Object,
      default: () => ({}),
    },

    expertConfig: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      selectPlatform: {},
    }
  },

  computed: {
    aboutUsContent() {
      return this.homeInfo?.homeContent?.title3?.split('##').join('<br>')
    },

    statementContent() {
      return this.homeInfo?.homeContent?.title4?.split('##').join('<br>')
    },

    siteDomain() {
      if (typeof window === 'undefined') {
        return ''
      }
      return window.location.hostname || ''
    },

    socList() {
      const links = this.homeInfo?.homeContent?.links
      if (!Array.isArray(links)) {
        return []
      }
      return links.map((row) => ({
        ...row,
        url: this.stripSvgFillAttrs(row?.url),
      }))
    },
  },

  methods: {
    /**
     * 去掉 SVG 字符串里所有内联 fill 属性（颜色可能不固定），由 CSS 统一控制
     */
    stripSvgFillAttrs(html) {
      if (!html || typeof html !== 'string') {
        return html
      }
      // 仅删除名为 fill 的属性（\sfill\s*=），不误删 fill-rule / fill-opacity
      return html
        .replace(/\sfill\s*=\s*["'][^"']*["']/gi, '')
        .replace(/\sfill\s*=\s*[^\s>]+/gi, '')
    },

    handleChangeExpert(platform) {
      this.selectPlatform = platform
    },

    /**
     * 同步光标坐标到 CSS 变量，驱动网格聚焦与柔光跟随
     */
    onPtrMove(e) {
      const root = this.$refs.t4Page
      const glow = this.$refs.glowEl
      if (!root || !glow) return
      glow.style.left = `${e.clientX}px`
      glow.style.top = `${e.clientY}px`
      root.style.setProperty('--cursor-x', `${e.clientX}px`)
      root.style.setProperty('--cursor-y', `${e.clientY}px`)
    },

    onPtrLeave() {
      const glow = this.$refs.glowEl
      if (glow) glow.style.opacity = '0'
    },

    onPtrEnter() {
      const glow = this.$refs.glowEl
      if (glow) glow.style.opacity = '0.55'
    }
  }
}
</script>

<style scoped>
.home-type4-root {
  position: relative;
  isolation: isolate;
  --grid-line-strong: hsl(from var(--primary-color) h s l / 0.3);
  --cursor-glow-strong: hsl(from var(--primary-color) h s l / 0.24);
  --cursor-glow-mid: hsl(from var(--primary-color) h s l / 0.09);
  --cursor-glow-fade: hsl(from var(--primary-color) h s l / 0);
  --cursor-x: 50vw;
  --cursor-y: 50vh;
}

/* 业务内容层级高于背景网格层，避免文字/图片被遮罩影响 */
.home-type4-root> :not(.grid-focus):not(.cursor-glow) {
  position: relative;
  z-index: 1;
}

.grid-focus {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  background-image:
    linear-gradient(var(--grid-line-strong) 1px, transparent 1px),
    linear-gradient(90deg, var(--grid-line-strong) 1px, transparent 1px);
  background-size: 64px 64px;
  background-attachment: fixed;
  -webkit-mask-image: radial-gradient(circle 130px at var(--cursor-x) var(--cursor-y),
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0.65) 45%,
      rgba(0, 0, 0, 0) 100%);
  mask-image: radial-gradient(circle 130px at var(--cursor-x) var(--cursor-y),
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0.65) 45%,
      rgba(0, 0, 0, 0) 100%);
}

.cursor-glow {
  position: fixed;
  left: 0;
  top: 0;
  width: 240px;
  height: 240px;
  border-radius: 50%;
  pointer-events: none;
  z-index: 0;
  opacity: 0.4;
  transform: translate(-50%, -50%);
  background: radial-gradient(circle,
      var(--cursor-glow-strong) 0%,
      var(--cursor-glow-mid) 35%,
      var(--cursor-glow-fade) 72%);
  filter: blur(14px);
}
</style>